import SearchSpeaker from './SearchSpeaker';

export default SearchSpeaker;
